import React from 'react';
import { useMainAnketaPresenter } from './MainAnketa.presenter';

import { PersonalInfo } from './components/PersonalInfo/PersonalInfo';
import { SignDocuments } from './components/SignDocuments';
import { SignPEP } from './components/SignPEP/SignPEP';
import { Work } from './components/Work';
import { SpecialConditions } from './components/SpecialСonditions/SpecialConditions';

import { VOID_FUNCTION } from 'constants';

import * as S from './MainAnketa.styles';

export const MainAnketa = ({
  className = '',
  data,
  errors,
  params,
  validate,
  firstTimeRender,
  forcedValidation,
  onChange = VOID_FUNCTION,
  onSave = VOID_FUNCTION,
}) => {
  const presenter = useMainAnketaPresenter({ data });

  return (
    <S.Wrapper className={className}>
      <PersonalInfo
        data={data}
        params={params}
        validate={validate}
        errors={errors}
        forcedValidation={forcedValidation}
        isContentHidden={presenter.isContentHidden}
        disabled={presenter.selfAgreement}
        setFocusAt={presenter.setFocusAt}
        onChange={onChange}
      >
        {presenter.isPEP && <SignPEP anketaData={data} anketaErrors={errors} onSave={onSave} />}
      </PersonalInfo>

      <Work
        data={data}
        validate={validate}
        errors={errors}
        firstTimeRender={firstTimeRender}
        disabled={presenter.isDisabled}
        setFocusAt={presenter.setFocusAt}
        onChange={onChange}
      />

      {presenter.isSpecialСonditions && <SpecialConditions isPickUp={presenter.isPickUp} />}

      {presenter.isShowDocuments && (
        <SignDocuments data={data} errors={errors} contentHidden={presenter.isContentHidden} />
      )}
    </S.Wrapper>
  );
};
